import React, { useState, useEffect, useRef } from "react";
import "../styles/MessagePage.css"
import { useTranslation } from 'react-i18next';
import { GoSun } from "react-icons/go";
import { FaGithubSquare, FaLinkedin } from "react-icons/fa";
import { BsFillSendFill } from "react-icons/bs";
import emailjs from '@emailjs/browser';
	
// Simple contact page shown at /message
const MessagePage = () => {
	const [isLightMode, setIsLightMode] = useState(() => {
		const saved = localStorage.getItem('lightMode');
		return saved ? JSON.parse(saved) : false;
	});
	const { t, i18n } = useTranslation();
	const normalizeLang = (lng) => (lng ? lng.split('-')[0] : 'en');
	const [language, setLanguage] = useState(normalizeLang(i18n.language));
	const form = useRef();
	const [showNotification, setShowNotification] = useState(false);
	const [notificationType, setNotificationType] = useState('success');


	useEffect(() => {
		localStorage.setItem('lightMode', JSON.stringify(isLightMode));
		if (isLightMode) {
			document.documentElement.classList.add('light-mode');
		} else {
			document.documentElement.classList.remove('light-mode');
		}
	}, [isLightMode]);

	useEffect(() => {
		setLanguage(normalizeLang(i18n.language));
	}, [i18n.language]);

	const toggleTheme = () => {
        setIsLightMode(!isLightMode);
    };

    const toggleLanguage = () => {
        const current = normalizeLang(language);
        const newLng = current === 'pt' ? 'en' : 'pt';
        setLanguage(newLng);
        i18n.changeLanguage(newLng);
    };

	const sendEmail = (e) => {
		e.preventDefault();

		emailjs.sendForm(
			process.env.REACT_APP_SERVICE_ID, 
			process.env.REACT_APP_TEMPLATE_ID, 
			form.current, 
			process.env.REACT_APP_PUBLIC_KEY
		)
		.then((result) => {
			console.log(result.text);
			setNotificationType('success');
			setShowNotification(true);
			form.current.reset();
			setTimeout(() => {
				setShowNotification(false);
			}, 5000);
		}, (error) => {
			console.log(error.text);
			setNotificationType('error');
			setShowNotification(true);
			setTimeout(() => {
				setShowNotification(false);
			}, 5000);
		});
	};

	return (
		<div className={`${isLightMode ? "messagePage light-mode" : "messagePage"} ${language === 'pt' ? 'lang-pt' : 'lang-en'}`}>
			<div className="theme-area">
				<button onClick={toggleLanguage} aria-label={language === 'pt' ? 'Switch to English' : 'Mudar para Português'} style={{fontSize: "40px"}}>
					<span className="icons" role="img" aria-hidden="true">{language === 'pt' ? '🇺🇸' : '🇧🇷'}</span>
				</button>
				<button onClick={toggleTheme} aria-label="Alterar tema">
					<GoSun className="icons"/>
				</button>
			</div>

			<div className="forms-area">
				<div style={{marginTop: "-70px"}}>
					<h1>{t('messageTitle')}</h1>
					<form ref={form} onSubmit={sendEmail}>
						<input type="name" name="name" placeholder={t('clientName')}/>
						<input type="email" name="email" placeholder={t('clientEmail')}/>
						<textarea name="message" placeholder={t('clientMessage')}/>
						<button type="submit">
							<BsFillSendFill style={{width: "42px", height: "42px"}}/>
							{t('buttonMessage')}
						</button>
					</form>
				</div>
			</div>

			<div className="social-area">
				<a href="https://github.com/Augusto-Ildefonso">
					<FaGithubSquare className="icons" style={{marginBottom: "0px"}}/>
				</a>
				<a href="https://www.linkedin.com/in/augustofernandesildefonso/" target="_blank" rel="noreferrer">
					<FaLinkedin className="icons"/>
				</a>
			</div>

			{showNotification && (
				<div className={`notification ${notificationType}`}>
					{notificationType === 'success' ? t('emailSuccess') : t('emailError')}
				</div>
			)}
		</div>
	);
};

export default MessagePage;
